<template>
  <div class="contact-us">
    <div class="title">Si desea contáctarnos, envíanos un mensaje</div>
    <form class="contact-form" @submit.prevent="sendEmail">
      <!-- <label>Name</label><br /> -->
      <input
        type="text"
        name="user_name"
        v-model="name"
        placeholder="Indicanos tu nombre"
      /><br />
      <!-- <label>Email</label><br /> -->
      <input
        type="email"
        name="user_email"
        v-model="email"
        placeholder="Añade tu correo electrónico"
      /><br />
      <!-- <label>Message</label><br /> -->
      <textarea
        name="message"
        placeholder="Mensaje"
        v-model="message"
      ></textarea
      ><br />
      <input
        class="btn btn-outline-secondary bottom"
        type="submit"
        value="Enviar"
      />
      <div class="d-flex justify-content-center">
        <div v-if="errors.length" class="alert alert-danger" role="alert">
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div v-if="ok.length" class="alert alert-success" role="alert">
          <ul>
            <li v-for="message in ok" :key="message">{{ message }}</li>
          </ul>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  data() {
    return {
      errors: [],
      name: null,
      email: null,
      message: null,
      ok: []
    };
  },
  methods: {
    sendEmail(e) {
      this.errors = [];
      this.ok = [];
      if (!this.name) {
        this.errors.push("Debe ingresar su nombre");
      }
      if (!this.email) {
        this.errors.push("Debe ingresar su correo");
      }
      if (this.name && this.email) {
        emailjs
          .sendForm(
            "gmail",
            "template_vVKTs1gX",
            e.target,
            "user_1mfi64yFY1siAgPNhoU80"
          )
          .then(
            // eslint-disable-next-line no-unused-vars
            result => {
              this.ok.push("Mensaje Enviado");
            },
            // eslint-disable-next-line no-unused-vars
            error => {
              return;
            }
          );
      }
    },
    checkForm: function() {}
  }
};
</script>
<style scoped>
#contact-us {
  background-color: #ebf5ee;
  margin-top: 30px;
}
.title {
  padding-top: 50px;
  background-color: #ebf5ee;
  font-size: 22px;
  color: #242325;
  margin-bottom: 10px;
}
input {
  width: 300px;
  height: 40px;
  padding: 0 10px;
  border: 2px solid #a3a39e;
  border-radius: 2px;
  margin-bottom: 20px;
}
textarea {
  width: 300px;
  padding: 5px 10px;
  border: 2px solid #a3a39e;
  border-radius: 2px;
  margin-bottom: 20px;
}
::placeholder {
  color: #a3a39e;
}
.btn {
  width: 150px;
  background-color: white;
  color: #a3a39e;
  border: 3px solid;
  line-height: 2em;
  border-radius: 0.5em;
  transition: 0.3s;
}

.btn:hover {
  background-color: #a3a39e;
  border: 3px solid #a3a39e;
  color: white;
}
.alert {
  width: auto;
}
ul {
  margin: 0;
}
@media screen and (min-width: 768px) {
  .title {
    font-size: 36px;
    margin-bottom: 30px;
  }
  input {
    width: 500px;
  }
  textarea {
    width: 500px;
    height: 100px;
  }
}
</style>
